import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import Groups from "src/components/panel/groups/Groups";

const GroupsView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("groups_list_tab")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb title={t("groups_list_title")} />
        <Groups />
      </Sidebar>
    </>
  );
};

export default GroupsView;
